import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Instancias from './pages/Instancias';
import Mensagens from './pages/Mensagens';
import Webhook from './pages/Webhook';
import Configuracoes from './pages/Configuracoes';

const theme = createTheme({
  palette: {
    primary: {
      main: '#25d366',
      contrastText: '#fff',
    },
    secondary: {
      main: '#128c7e',
    },
  },
});

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/instancias"
              element={
                <PrivateRoute>
                  <Layout>
                    <Instancias />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/mensagens"
              element={
                <PrivateRoute>
                  <Layout>
                    <Mensagens />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/webhook"
              element={
                <PrivateRoute>
                  <Layout>
                    <Webhook />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/configuracoes"
              element={
                <PrivateRoute>
                  <Layout>
                    <Configuracoes />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <ToastContainer />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 